import { IReportService } from "../../service/report/ReportService";

export default class GetDataReport4Interactor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(reportingPeriodId: number, riskCriteriaList: number[]) {
    return this.reportService.getDataReport4(
      reportingPeriodId,
      riskCriteriaList
    );
  }
}
